module.exports = __webpack_public_path__ + "static/45327ea7.supply2.png";